import React from 'react';

const CustomerBookingUrlField = ({record}) => (
    <a href={`#/bookings?filter={"customer":"${record.id}"}&order=ASC&page=1&perPage=10&sort=id`}>Бронювання</a>
);
CustomerBookingUrlField.defaultProps = {
    addLabel: true,
};

export default CustomerBookingUrlField;